<template lang="pug">
  div.row
    el-col(:span="10")
      el-checkbox(:label="label", v-model="checked" v-on:change="changeCheckbox")
        div.text
          slot
    el-col(:span="14" v-if="haveInput")
      el-form(:model="form", ref="form", :rules="rule1")
        el-form-item(prop="input")
          el-input(v-model.number="form.input" , placeholder="คะแนน", v-on:input="updateSkill($event)").short
</template>
<style lang="scss" scoped>
.row {
  display: flex;
  justify-content: space-between;
  margin: 0 0 15px 0;
}
.text {
  color: #606266;
  font-size: 18px;
  font-weight: 400;
  line-height: 2.2;
}
.el-checkbox {
  margin-right: 10px
}

.short {
  max-width: 220px;
}
</style>

<style lang="scss">
.el-form-item__error {
  padding-top: 2px;
}
</style>

<script>
export default {
  name: 'skillCheckbox',
  props: {
    label: {
      type: String,
    },
    skillScores: {
      type: Array,
    },
    skills: {
      type: Array,
    },
    prop: {
      type: Array,
      required: false,
    },
    haveInput: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data () {
    return {
      checked: false,
      form: {
        input: null,
      },
      localSkillScores: [],
      localSkills: [],
      rule1: {
        input: [
          { required: false, type: 'number', min: 0, max: 10, message: 'กรุณากรอกตัวเลข 0-10', trigger: 'blur' },
        ],
      },
    }
  },
  watch: {
    skillScores (newSkill) {
      this.localSkillScores = newSkill
      const item = newSkill.filter((item) => {
        return item.name === this.label
      })
      if (item[0]) {
        this.form.input = item[0].score === 0 ? 0 : item[0].score
      }
    },
    skills (newSkill, oldSkill) {
      this.localSkills = newSkill
      this.checked = this.localSkills.indexOf(this.label) !== -1
    },
  },
  methods: {
    updateSkill (text) {
      this.form.input = this.form.input === '' ? 0 : this.form.input
      this.removeSkill()
      if (!isNaN(Number(this.form.input)) && !(!this.checked && Number(this.form.input) === 0)) {
        this.localSkillScores.push({ name: this.label, score: Number(this.form.input) })
        if (this.checked) this.localSkills.push(this.label)
      }
      this.$emit('update:skillScores', this.localSkillScores)
      this.$emit('update:skills', this.localSkills)
    },
    changeCheckbox (state) {
      if (this.haveInput) {
        this.$refs['form'].clearValidate()
      }
      if (this.checked === false) {
        this.form.input = this.form.input === 0 ? null : this.form.input
        this.removeSkill()
        if (this.label === 'woundCare') {
          this.removeAllWoundCare()
        }
        this.$emit('update:skillScores', this.localSkillScores)
        this.$emit('update:skills', this.localSkills)
      } else {
        this.updateSkill()
      }
    },
    removeSkill () {
      this.localSkillScores = this.localSkillScores.filter((item) => {
        return item.name !== this.label
      })
      this.localSkills = this.localSkills.filter((item) => {
        return item !== this.label
      })
    },
    removeAllWoundCare () {
      this.localSkillScores = this.localSkillScores.filter((item) => {
        return item.name !== 'woundCareLevel1'
      })
      this.localSkills = this.localSkills.filter((item) => {
        return item !== 'woundCareLevel1'
      })
      this.localSkillScores = this.localSkillScores.filter((item) => {
        return item.name !== 'woundCareLevel2'
      })
      this.localSkills = this.localSkills.filter((item) => {
        return item !== 'woundCareLevel2'
      })
      this.localSkillScores = this.localSkillScores.filter((item) => {
        return item.name !== 'woundCareLevel3'
      })
      this.localSkills = this.localSkills.filter((item) => {
        return item !== 'woundCareLevel3'
      })
    },
  },
}
</script>
